import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dd04db0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Unsubscribe Agent ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Remove ")

import { computed, ref, VNodeRef } from 'vue';
import { License_RegisterAgentAction } from '@/graphql/codegen/generated/graphql';
import AgentsAddBuildGroup from '@/views/agents/components/action-menu/agents-build-group.vue';
import AgentsServerSubscription from '@/views/agents/components/action-menu/agents-server-subscription.vue';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { SelectedAgent } from '@/components/agents-table/AgentActionMenu.types';
import { useAgentsTableUtils } from '@/views/agents/components/agents-table/agent-table-list/OS/agents-table.utils';
import AgentActionSetDescription from '@/components/agents-table/AgentActionSetDescription.vue';
import manageBuildGroupsDialog from '@/views/agents/components/buildGroups/manageBuildGroupsDialog.vue';
import { useIncrediDialog } from 'incredi-ui';
import { useAgentActionsMenu } from '../../../../AgentActionsMenu.helpers';
import { useNotifyPresets } from '../../../../services/notifyPresets';
import AgentCloudBulkActionMenu from '../../../../AgentCloudBulkActionMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentBulkActionMenu.linux',
  props: {
    modelValue: { type: [Boolean, null] },
    agents: null,
    target: null,
    menuOptions: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:model-value', value: boolean | undefined): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: boolean | undefined;
  agents: SelectedAgent[];
  target: string;
  menuOptions: {
    attrs: Record<string, any>;
    listeners: Record<string, ((e: any) => void) | undefined>;
  };
}

const { notifyPresets } = useNotifyPresets();
const IcmMenuRef = ref<VNodeRef>();

const agentsActions = useAgentActionsMenu(OsType.Linux, IcmMenuRef);
const agentsTableUtils = useAgentsTableUtils();
const dialog = useIncrediDialog();


// eslint-disable-next-line no-unused-vars

const isDefaultMenu = computed(() => props?.agents.some(agent => !agent.metadata?.isCloud && !agent.metadata?.isOffline));
const isContainsOfflineAgent = computed(() => props?.agents.some(agent => agent.metadata?.isOffline));
const isContainsCloudAgents = computed(() => props.agents.some(agent => agent.metadata?.isCloud));
const isContainsSubscribedAgents = computed(() => props.agents.some(agent => agent?.license?.status));
const isContainsCloudStoppedAgents = computed(() => props.agents.some(agent => agentsTableUtils.isCloudAgentInStatusStoppedOrUpdating(agent)));
const openBuildGroupsDialog = () => {
  if (IcmMenuRef?.value) (IcmMenuRef?.value as any).hide(); // close agent actions menus
  dialog?.open('manageBuildGroupsDialog', manageBuildGroupsDialog, {});
};

return (_ctx: any,_cache: any) => {
  const _component_icm_menu_submenu = _resolveComponent("icm-menu-submenu")!
  const _component_icm_menu_item = _resolveComponent("icm-menu-item")!
  const _component_icm_menu = _resolveComponent("icm-menu")!
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return _withDirectives((_openBlock(), _createBlock(_component_icm_menu, _mergeProps({
    ref_key: "IcmMenuRef",
    ref: IcmMenuRef,
    "hover-mode": "",
    "open-menu": __props.modelValue,
    target: __props.modelValue ? __props.target : false
  }, __props.menuOptions.attrs, _toHandlers(__props.menuOptions.listeners), {
    "onUpdate:openMenu": _cache[5] || (_cache[5] = (newVal) => emit('update:model-value', newVal))
  }), {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.agents.length) + " Agents Selected ", 1)
    ]),
    default: _withCtx(({ bind }) => [
      (_unref(isDefaultMenu))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 0,
            anchor: "top right",
            self: "top left"
          }, bind, {
            portal: "",
            label: "Subscribe Agent"
          }), {
            default: _withCtx(() => [
              _createVNode(AgentsServerSubscription, {
                agents: __props.agents,
                onChange: _unref(agentsActions).setAgentsLicense
              }, null, 8, ["agents", "onChange"])
            ]),
            _: 2
          }, 1040))
        : _createCommentVNode("", true),
      (_unref(isDefaultMenu))
        ? (_openBlock(), _createBlock(_component_icm_menu_submenu, _mergeProps({
            key: 1,
            anchor: "top right",
            self: "top left"
          }, bind, {
            portal: "",
            label: "Build Group"
          }), {
            default: _withCtx(() => [
              _createVNode(AgentsAddBuildGroup, {
                agents: __props.agents,
                onOpenDialog: _cache[0] || (_cache[0] = () => openBuildGroupsDialog()),
                onChange: _cache[1] || (_cache[1] = 
            value => {
              value.status ? _unref(agentsActions).setBuildGroup(__props.agents, value.buildGroup) : _unref(notifyPresets).agentSingeActionFail();
            }
          )
              }, null, 8, ["agents"])
            ]),
            _: 2
          }, 1040))
        : _createCommentVNode("", true),
      _createVNode(_component_icm_menu_submenu, _mergeProps({
        anchor: "top right",
        self: "top left",
        portal: "",
        label: 'Agent Description'
      }, bind), {
        default: _withCtx(() => [
          _createVNode(AgentActionSetDescription, {
            "agents-list": __props.agents,
            onSubmit: _cache[2] || (_cache[2] = (value) => _unref(agentsActions).setAgentDescription(__props.agents,value))
          }, null, 8, ["agents-list"])
        ]),
        _: 2
      }, 1040),
      (_unref(isDefaultMenu) && _unref(isContainsSubscribedAgents))
        ? (_openBlock(), _createBlock(_component_icm_menu_item, {
            key: 2,
            "data-testid": "unsubscribe-agent-action",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(agentsActions).setRemoveAgentLicense(__props.agents, _unref(License_RegisterAgentAction).UnsubscribeAgent)))
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(isContainsCloudAgents) && !_unref(isContainsCloudStoppedAgents))
        ? (_openBlock(), _createBlock(AgentCloudBulkActionMenu, _mergeProps({
            key: 3,
            "hover-mode": "",
            agents: __props.agents
          }, _toHandlers(__props.menuOptions.listeners)), null, 16, ["agents"]))
        : _createCommentVNode("", true),
      (_unref(isContainsOfflineAgent))
        ? (_openBlock(), _createBlock(_component_icm_menu_item, {
            key: 4,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(agentsActions).removeAgentLinux(__props.agents)))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["open-menu", "target"])), [
    [_directive_incredi_focus_trap, 'agent-bulk-action-menu']
  ])
}
}

})